<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Investidor"
      title="Dashboard Investidor"
      :displaySidebar="displaySidebar"
    >
      <template slot="links">
        <!-- menu links -->
        <sidebar-item
          v-for="link in menu.links"
          :key="link.path"
          :link="link"
        />
      </template>
    </side-bar>
    <div
      class="main-content"
      :data="sidebarBackground"
      v-if="isSupportRoute || investor.validated"
    >
      <i
        class="fa fa-bars btn-toggle d-none d-md-block"
        @click="toggleDisplaySidebar()"
      ></i>
      <dashboard-navbar :name="investor.name"></dashboard-navbar>
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
    <content-footer
      v-if="!$route.meta.hideFooter"
      :showSocial="displaySidebar"
    ></content-footer>
    <initial-info-modal
      v-if="!isSupportRoute || !investor.name"
      v-on:investor_name="handleInvestorName($event)"
      v-on:investor_validated="handleInvestorValidated($event)"
    />
  </div>
</template>
<script>
import DashboardNavbar from "./../DashboardNavbar.vue";
import ContentFooter from "./../ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import InitialInfoModal from "@/views/Investor/Dashboard/InitialInfoModal";

import menu from "./menu.json";

export default {
  name: "dashboard-investor",
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
    InitialInfoModal,
  },
  data() {
    return {
      investor: {
        name: "",
        validated: false,
      },
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      menu: menu,
      displaySidebar: true,
    };
  },
  methods: {
    handleInvestorName(e) {
      this.investor.name = e;
    },
    handleInvestorValidated(e) {
      this.investor.validated = e;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleDisplaySidebar() {
      this.displaySidebar = !this.displaySidebar;
    },
  },
  computed: {
    isSupportRoute() {
      return this.$route.name === "investidor_suporte";
    },
  },
};
</script>
